module.exports = __webpack_public_path__ + "assets/images/drink_r.9ce939e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/drink_r.png
// module id = 704
// module chunks = 1